import { DownloadOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { formatDate } from "utils/dateFormat";
import { useAppSelector } from "store";
import { getExportTransportInprocess } from "services/shipping";

const ExportToExcel = () => {
  const [loading, setLoading] = useState(false);
  const usrName = useAppSelector((state) => state.auth.profile?.user?.name);

  const fecthData = async () => {
    try {
      const response = await getExportTransportInprocess();
      if (response.status === "success" && response) {
        return response.data;
      }
    } catch (error) {
      console.log(error);

      return undefined;
    } finally {
      // setLoading(false)
    }
  };

  const exportToExcel = async () => {
    // console.log('exportToExcel')

    setLoading(true);

    try {
      let data = await fecthData();

      let arr = data?.map((item, index) => {
        const newData = {
          ลำดับ: index + 1,
          เลขที่คำสั่งซื้อ: item.order_code,
          วันที่สั่งซื้อ: formatDate(item.order_date),
          ประเภทการจัดส่ง: item.transport_name,
          ผู้รับ: item.address_name,
          เบอร์โทรศัพท์ผู้รับ: item.address_telephone,
          จังหวัด: item.province_name,
          อำเภอ: item.district_name,
          ตำบล: item.sub_district_name,
          ที่อยู่ผู้รับ: item.address_text,
          ชื่อสินค้า: item.product_name,
          ตัวเลือก: item.sku_name,
          จำนวน: item.qty,
          ประเภทสินค้า: item.category_name,
          โน๊ตผู้ประกอบการ: item.contact_comment_item,
        };

        return newData;
      });

      //  console.log(arr)

      if (arr) {
        let Heading = [
          [
            "ลำดับ",
            "เลขที่คำสั่งซื้อ",
            "วันที่สั่งซื้อ",
            "ประเภทการจัดส่ง",
            "ผู้รับ",
            "เบอร์โทรศัพท์ผู้รับ",
            "จังหวัด",
            "อำเภอ",
            "ตำบล",
            "ที่อยู่ผู้รับ",
            "ชื่อสินค้า",
            "ตัวเลือก",
            "จำนวน",
            "ประเภทสินค้า",
            "โน๊ตผู้ประกอบการ"
          ],
        ];

        const tableName = `Prepare Shipping`;
        const exportDate = `Export Date: ${moment(new Date()).format("DD-MM-YYYY")}`;
        const exportName =  `User: ${usrName}`;
                const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_aoa(ws, [[tableName]], { origin: "A1" });
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
        XLSX.utils.sheet_add_aoa(ws, [[exportName]], { origin: "A2" });
        XLSX.utils.sheet_add_aoa(ws, [[exportDate]], { origin: "A3" });
        XLSX.utils.sheet_add_aoa(ws, Heading,  { origin: "A5" });
        XLSX.utils.sheet_add_json(ws, arr, { origin: "A6", skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, genfileName());
      } else {
        message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const genfileName = () => {
    const date = new Date();
    const fileName = `export_prepare_shipping_${moment(date).format(
      "DD-MM-YYYY"
    )}.xlsx`;
    return fileName;
  };

  return (
    <Button
      type="default"
      style={{ marginRight: 10 }}
      icon={<DownloadOutlined />}
      size="middle"
      loading={loading}
      onClick={exportToExcel}
    >
      ส่งออก Excel
    </Button>
  );
};

export default ExportToExcel;
